// Single source of truth for activity constants
// These values come from the Ruby Place model via window.MPF_ACTIVITIES

// Get activities from Ruby object or use defaults for backwards compatibility
const MPF = window.MPF_ACTIVITIES || {
  UNDERTAKER: 'undertaker',
  MARBLE: 'marble',
  CREMATORIUM: 'crematorium',
  FUNERARIUM: 'funerarium',
  CEMETERY: 'cemetery',
};

// Named constants for readable access
export const { UNDERTAKER } = MPF;
export const { MARBLE } = MPF;
export const { CREMATORIUM } = MPF;
export const { FUNERARIUM } = MPF;
export const { CEMETERY } = MPF;

// Export the array for iteration
export const ACTIVITIES = [
  UNDERTAKER,
  MARBLE,
  CREMATORIUM,
  FUNERARIUM,
  CEMETERY,
];

// Validation helper
export function validateActivity(activity) {
  return ACTIVITIES.includes(activity) ? activity : UNDERTAKER;
}

// Mapping for singular to plural forms
export const SINGULAR_TO_PLURAL = {
  [UNDERTAKER]: 'undertakers',
  [MARBLE]: 'marbles',
  [CREMATORIUM]: 'crematoriums',
  [FUNERARIUM]: 'funerariums',
  [CEMETERY]: 'cemeteries',
};

// Mapping for plural to singular forms
export const PLURAL_TO_SINGULAR = {
  undertakers: UNDERTAKER,
  marbles: MARBLE,
  crematoriums: CREMATORIUM,
  funerariums: FUNERARIUM,
  cemeteries: CEMETERY,
};

// Path prefixes for different activities
export const ACTIVITY_PREFIX = {
  [UNDERTAKER]: '',
  [MARBLE]: '',
  [CREMATORIUM]: '/crematoriums',
  [FUNERARIUM]: '/funerariums',
  [CEMETERY]: '',
};

export function cityPath(departmentCode, citySlug) {
  return `/${departmentCode.toLowerCase()}/${citySlug}`;
}

// Helper function to generate paths
export function generatePath(
  activity,
  postalCode,
  departmentCode,
  citySlug,
  placeSlug,
) {
  let path = ACTIVITY_PREFIX[activity];
  path += cityPath(departmentCode, citySlug);

  if (
    [UNDERTAKER, MARBLE].includes(activity) &&
    ['paris', 'lyon', 'marseille'].includes(citySlug)
  ) {
    path += `/${postalCode.slice(-2)}`;
  }

  path += activity === CEMETERY ? '#cimetieres' : `/${placeSlug}`;

  return path;
}
